import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Accordion, SortableHeader } from '../../common/SharedComponents';
import { formatDate, formatCurrency } from '../../common/SharedFunctions';
import { getLoanTypeName } from '../../loans/common/LoanFunctions';
import { LoanStatusOptions } from '../../loans/common/LoanConstants';
import { LoanType } from '@apply/constants';

const LoanHistoryTable = ({ loans, masterNotes }) => {
    const [filteredLoans, setFilteredLoans] = useState([]);
    useEffect(() => {
        if (loans) {
            if (masterNotes) {
                setFilteredLoans(loans.filter((l) => l.loanType == LoanType.MasterNote));
            } else {
                setFilteredLoans(loans.filter((l) => l.loanType != LoanType.MasterNote));
            }
        }
    }, [loans, masterNotes]);

    const [sort, set_sort] = React.useState({
        column: 'name',
        direction: 'asc',
    });

    const activeColumns = [
        { key: 'Loan #', label: 'Loan #', id: 'bfiNumber' },
        { key: 'Type', label: 'Type', id: 'loanType' },
        { key: 'Commitment', label: 'Commitment', id: 'commitment' },
        { key: 'Closing Date', label: 'Closing Date', id: 'closingDate' },
        { key: 'Status', label: 'Status', id: 'statusId' },
    ];

    const activeMasterNoteColumns = [
        { key: 'Loan #', label: 'Loan #', id: 'bfiNumber' },
        { key: 'Type', label: 'Type', id: 'loanType' },
        { key: 'Commitment', label: 'Total Credit Line', id: 'commitment' },
        { key: 'Closing Date', label: 'Closing Date', id: 'closingDate' },
        { key: 'Status', label: 'Status', id: 'statusId' },
    ];

    const sortedRows = _.chain(filteredLoans).orderBy(sort.column, sort.direction).value();

    const styles = {
        tableWidth: {
            width: 550,
        },
        noPaddingTop: {
            paddingTop: 0,
        },
        noBoxShadow: {
            boxShadow: 'none',
        },
    };

    return (
        <Accordion isCollapsable={false}>
            <div
                className='card'
                style={styles.noBoxShadow}
            >
                <div className='card-section'>
                    <h2 style={{ paddingBottom: '10px' }}>{masterNotes ? 'Master Note' : 'Other Loans'}</h2>
                    <table style={styles.tableWidth}>
                        <thead>
                            <tr>
                                {masterNotes &&
                                    activeMasterNoteColumns.map((col) => (
                                        <SortableHeader
                                            key={col.key}
                                            column={col}
                                            sort={sort}
                                            onPress={set_sort}
                                            style={styles.noPaddingTop}
                                        />
                                    ))}
                                {!masterNotes &&
                                    activeColumns.map((col) => (
                                        <SortableHeader
                                            key={col.key}
                                            column={col}
                                            sort={sort}
                                            onPress={set_sort}
                                            style={styles.noPaddingTop}
                                        />
                                    ))}
                            </tr>
                        </thead>
                        <tbody>
                            {sortedRows &&
                                sortedRows.map((loan) => (
                                    <tr key={loan.bfiNumber}>
                                        <td className='primary'>{loan.bfiNumber}</td>
                                        <td className='secondary'>{getLoanTypeName(loan.loanType)}</td>
                                        <td className='secondary'>{formatCurrency(loan.commitment, 0)}</td>
                                        <td className='secondary'>{formatDate(new Date(loan.closingDate))}</td>
                                        <td className='secondary'>
                                            {LoanStatusOptions.find((s) => s.id === loan.statusId)?.name}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Accordion>
    );
};

export default LoanHistoryTable;
